import React, { useEffect, useRef } from 'react';
import { usePageSplitClasses } from '../hooks';
export const PageSplitPanelFlex = ({ children, className: optionalClassName, splitType, parentRef, firstSplitSize, }) => {
    const { panelFlex } = usePageSplitClasses(optionalClassName, splitType);
    const refObject = useRef(null);
    useEffect(() => {
        if ((parentRef === null || parentRef === void 0 ? void 0 : parentRef.current) && firstSplitSize && refObject.current) {
            if (splitType === 'vertical-divider') {
                const paneSize = parentRef.current.clientWidth - firstSplitSize;
                refObject.current.style.width = `${paneSize}px`;
            }
            if (splitType === 'horizontal-divider') {
                const paneSize = parentRef.current.clientHeight - firstSplitSize;
                refObject.current.style.height = `${paneSize}px`;
            }
        }
    }, [firstSplitSize, parentRef, refObject, splitType]);
    return (React.createElement("div", { "data-testid": "PageSplitPanelFlex", ref: refObject, className: panelFlex }, children));
};
//# sourceMappingURL=PageSplitPanelFlex.js.map